import React, { useState } from 'react';
import { Comment, Tooltip, Icon, Tag } from 'antd';
import classNames from 'classnames';
import moment from 'moment';
import Linkify from 'react-linkify';
import Iframe from 'react-iframe'

import './Message.scss'
import AuthorAvatar from './AuthorAvatar';
import { deleteMessage } from '../api';
import BranchMessageAction from './BranchMessageAction';
import { useGlobalState } from '../state';
import { SummaryAction, SummaryVoteYes, SummaryVoteNo } from './SummaryActions';


function MessageTime({ time, }) {
  return <span>{moment(time).fromNow()}</span>
}

const SUMMARY_STATUS_COLORS = {
  approved: 'green',
  pending: 'gold',
  rejected: 'volcano'
}

const EXTERNAL_LINK_PROPS = { target: '_blank', rel: 'noopener noreferrer' }

function Message({ value }) {
  const { author, message, timestamp, id, type, branch, summary_of, summary_status } = value;
  const [isMouseHovered, setMouseHovered] = useState(false);
  const [, setCurrentChannel] = useGlobalState('currentChannel');

  const isOnMainBranch = branch === 'main';
  const isApprovedSummary = type === 'summary' && summary_status === 'approved';
  const isPendingSummary = type === 'summary' && summary_status === 'pending';
  const isRejectedSummary = summary_status === 'rejected';
  const actionDisplayClassName = classNames({ hidden: !isMouseHovered })
  const iframe = type === 'iframe';

  if(iframe){
    return (
      <div
      className={classNames('__Iframe__')}
      >
        <Iframe url={message}

              width="100%"
                height="400px"
              styles={{height: "400px"}}/>
        </div>
    );

  }

  return (
    <div
      className={classNames('__Message__', { 'summary-approved': isApprovedSummary, 'summary-pending': isPendingSummary })}
      onMouseEnter={() => { setMouseHovered(true); }}
      // set it to true if component is create while mouse is over (mouse enter doesn't fire in that case)
      onMouseOver={() => { !isMouseHovered && setMouseHovered(true); }}
      onMouseLeave={() => { setMouseHovered(false); }}
    >
      <Comment
        datetime={
          <span>
            <MessageTime time={timestamp} />
            {isApprovedSummary && summary_of &&
              <Tag
                style={{ marginLeft: '1rem' }}
                onClick={() => { setCurrentChannel(summary_of); }}
                color="#108ee9">
                {summary_of}
              </Tag>}
            {summary_status && !summary_of &&
              <Tag
                color={SUMMARY_STATUS_COLORS[summary_status]}
                style={{ marginLeft: '1rem', cursor: 'text' }}
              >
                {summary_status}
              </Tag>}
          </span>
        }

        author={author}
        avatar={<AuthorAvatar authorName={author} />}
        content={<Linkify properties={EXTERNAL_LINK_PROPS}>{message}</Linkify>}
        actions={[
          !isApprovedSummary && (
            <span className={actionDisplayClassName}>
              <BranchMessageAction message={value} />
            </span>),
          !isOnMainBranch && !isPendingSummary && !isRejectedSummary && (
            <span className={actionDisplayClassName}>
              <SummaryAction message={value} />
            </span>),
          !isOnMainBranch && (isPendingSummary || isRejectedSummary) && (
            <span className={actionDisplayClassName}>
              <SummaryVoteYes message={value} disabled={isRejectedSummary} />
            </span>),
          !isOnMainBranch && (isPendingSummary || isRejectedSummary) && (
            <span className={actionDisplayClassName}>
              <SummaryVoteNo message={value} disabled={isRejectedSummary} />
            </span>),
          <span className={actionDisplayClassName}>
            <Tooltip title="Delete">
              <Icon
                onClick={async () => { await deleteMessage(id); }}
                type="delete"
              />
            </Tooltip>
          </span>
        ]} />
    </div>
  );
}

export default Message;
